import { useSelector } from 'react-redux';

import { selectFleet } from '../selectors';
import { timezonesEnum } from '../utils';

export const useTimezone = (fleetTimezone?: string): string => {
  const fleetFromStore = useSelector(selectFleet);

  return fleetTimezone || fleetFromStore?.timezone || timezonesEnum.AMERICA_NEW_YORK;
};
